module.exports = __webpack_public_path__ + "img/c6cc9de92621f2e9e8409093f953c4ca.png";